// mui component
import Box from "@mui/material/Box";
import { userState } from "../interface/MainInterface";
import { Button, CardMedia, Stack } from "@mui/material";
interface propsType {
  userState: userState;
}

const LiveHome = (props: propsType) => {
  return (
    <>
      <Box sx={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "#000000" }}>
        <Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Stack direction={"column"} spacing={4} sx={{ alignItems: "center" }}>
            <CardMedia component={"img"} image="/images/logo-white.png" sx={{ width: "50%" }}></CardMedia>
            <Button
              variant="text"
              onClick={() => {
                window.location.href = "https://ezwel-admin.livehyundai.com/";
              }}
            >
              {"관리자 페이지 바로가기"}
            </Button>
          </Stack>
        </Box>
      </Box>
    </>
  );
};

export default LiveHome;
